import styled from 'styled-components';
import { DialogActions } from '@material-ui/core';

const ModalPage = styled.div`
  width: 400px;

  display: flex;
  flex-direction: column;
  hr {
    background: #cacfd3;
    margin: 0;
  }
  .MuiDialogContent-root {
    padding: 0;
    min &:first-child {
      padding-top: 0;
    }
  }
  .header {
    padding: 0 20px 20px;
    font-size: 18px;
    font-weight: 600;
    color: #192637;
    border-bottom: 1px solid rgb(202, 207, 211);
  }
  .body {
    flex: 1;
    padding: 0 20px 30px 20px;
  }
`;

export const ModalFooter = styled(DialogActions)`
  border-top: 1px solid rgb(202, 207, 211);
  padding: 10px 0px;
`;

export default ModalPage;
